import React, { useCallback, useEffect, useState } from 'react';
import { Icons } from 'icons';
import { useRouter } from 'views/useRouter';

import { BoardList } from 'components/board';
import BaseOverflowTooltip from 'components/common/overflow-tooltip/BaseOverflowTooltip';
import { classnames } from 'lib/classnames';
import fetch from 'lib/fetch';
import useI18n from 'lib/hooks/useI18n';
import useToken from 'lib/hooks/useToken';
import { Workspace } from 'lib/types/models';

import styles from './index.module.less';

const cx = classnames(styles);
const SideContent: React.FC<{
  workspace: Workspace;
  boardId: string;
  hasAdminRole: boolean;
}> = ({ workspace, boardId, hasAdminRole }) => {
  const { t } = useI18n();
  // URL参数
  const router = useRouter();
  const { tenant } = useToken();
  const [hover, setHover] = useState(false);
  const handleGoToSetting = useCallback(() => {
    router.push(`/${tenant}/workspaces/${router.query.workspace}/settings/info`);
  }, [router, tenant]);
  const [settingAuth, setSettingAuth] = useState(undefined);

  // 初始化的空间设置进入权限
  useEffect(() => {
    const getSettingAuth = async (workspaceId: string) => {
      const result = await fetch.get(`/permissions/settings/${workspaceId}`);
      setSettingAuth(result.data?.settingAuth);
    };
    if (workspace?.objectId && hasAdminRole === undefined) {
      // 请求接口
      getSettingAuth(workspace.objectId);
    } else {
      // 如果hasAdminRole有值，也是直接用
      setSettingAuth(hasAdminRole);
    }
  }, [workspace, hasAdminRole, settingAuth]);

  return (
    <>
      <div className={cx('board-list-wrapper')}>
        <BoardList workspace={workspace} boardId={boardId} />
      </div>
      {settingAuth && (
        <div
          className={cx('workspace-sidebar-setting')}
          onClick={handleGoToSetting}
          onMouseOver={() => setHover(true)}
          onMouseOut={() => setHover(false)}
        >
          {hover ? (
            <Icons.Panel_SettingsB className={cx('workspace-sidebar-setting-icon')} />
          ) : (
            <Icons.Panel_Settings className={cx('workspace-sidebar-setting-icon')} />
          )}
          <BaseOverflowTooltip title={t('views.layout.default.workspaceSidebarSetting')}>
            {t('views.layout.default.workspaceSidebarSetting')}
          </BaseOverflowTooltip>
        </div>
      )}
    </>
  );
};

export default SideContent;
